import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "./api";

/**
 * Single QueryClient per app. Defaults match CP-00 §F (data freshness):
 *   - 30 s stale window — list views feel live without hammering API
 *   - 5 min garbage collection — keep deep details warm across nav
 *   - retry only on transient (5xx / network) errors; don't retry 4xx
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 300_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
